<div
    class="mobile-layout"
    [ngClass]="{ 'dashboard-background': topic === 'dashboard' }"
    >
    <div class="screen" *ngIf="currentScreen === 1" [@fadeInRight]>
        <branches
            *ngIf="topic === 'branches'"
            [isMobile]="true"
            (branchSelected)="selectItem($event)"
            ></branches>
        <users
            *ngIf="topic === 'users'"
            (userSelected)="selectItem($event)"
            ></users>
        <departments
            *ngIf="topic === 'departments'"
            (departmentSelected)="selectItem($event)"
            ></departments>
        <priority
            *ngIf="topic === 'priority'"
            (prioritySelected)="selectItem($event)"
            ></priority>
        <status
            *ngIf="topic === 'status'"
            (statusSelected)="selectItem($event)"
            ></status>
        <tags *ngIf="topic === 'tags'" (tagSelected)="selectItem($event)"></tags>
        <ng-container *ngIf="topic === 'tickets'">
            <header-filters
                (filterClicked)="toggleFilterForTicket()"
                ></header-filters>
            <ticket
                *ngIf="topic === 'tickets' && !showListByBranch"
                (ticketSelected)="selectItem($event)"
                ></ticket>
            <ticket-by-branch
                *ngIf="topic === 'tickets' && showListByBranch"
                [isMobile]="true"
                (ticketSelected)="selectItem($event)"
                ></ticket-by-branch>
        </ng-container>
        <ng-container *ngIf="topic === 'dashboard'">
            <dashboard></dashboard>
        </ng-container>
    </div>

    <ng-container *ngIf="currentScreen === 3">
        <app-menu class="menu-card" (itemSelected)="selectItem($event)"></app-menu>
    </ng-container>
    <div class="details" [class.details-active]="currentScreen === 2" [@fadeInRight]>
        <ng-container *ngIf="currentScreen === 2">
            <div class="details-content">
                <branch-details
                    *ngIf="(current_topic | async) === 'branches'"
                    class="branch-details-mobile"
                    ></branch-details>
                <user-details
                    *ngIf="(current_topic | async) === 'users'"
                    class="user-details-mobile"
                    >
                </user-details>
                <departments-details
                    *ngIf="(current_topic | async) === 'departments'"
                    class="departments-details-mobile"
                    ></departments-details>
                <priority-details
                    *ngIf="(current_topic | async) === 'priority'"
                    class="priority-details-mobile"
                    ></priority-details>
                <status-details
                    *ngIf="(current_topic | async) === 'status'"
                    class="status-details-mobile"
                    ></status-details>
                <tags-details
                    *ngIf="(current_topic | async) === 'tags'"
                    class="tags-details-mobile"
                    ></tags-details>

                <ng-container
                    *ngIf="
                    (current_topic | async) === 'tickets' &&
                    currentNav.action !== 'multi-process'
                    "
                    class="ticket-details-mobile"
                    >
                    <ng-container *ngIf="!showFilterPalette">
                        <ticket-details> </ticket-details>
                    </ng-container>
                </ng-container>
                <ng-container
                    *ngIf="
                    (current_topic | async) === 'tickets' &&
                    currentNav.action === 'multi-process'
                    "
                    >
                    <processing></processing>
                </ng-container>

                <ng-container *ngIf="showFilterPalette">
                    <div class="filter-palette-wrap">
                        <filter-for-ticket></filter-for-ticket>
                        <header-filters></header-filters>
                    </div>
                </ng-container>
            </div>
        </ng-container>
    </div>

    <div class="screen" *ngIf="currentScreen === 4">
        <branches
            *ngIf="chooseTopic === 'branches'"
            [isMobile]="true"
            [choiceEvent]="currentChoice"
            ></branches>
        <users
            *ngIf="chooseTopic === 'users'"
            [choiceEvent]="currentChoice"
            ></users>
        <departments
            *ngIf="chooseTopic === 'departments'"
            [choiceEvent]="currentChoice"
            ></departments>
        <priority
            *ngIf="chooseTopic === 'priority'"
            [choiceEvent]="currentChoice"
            ></priority>
        <status
            *ngIf="chooseTopic === 'status'"
            [choiceEvent]="currentChoice"
            ></status>

        <multi-action
            *ngIf="chooseTopic === 'multi-action'"
            [choiceEvent]="currentChoice"
            ></multi-action>
    </div>
</div>
<div class="menu">
    <mobile-menu
        (itemSelected)="selectItem($event)"
        (toggleMenu)="goToMenu()"
        (backClicked)="goBack()"
        ></mobile-menu>
</div>
